
export const ALL_CHATS_REQUEST = "ALL_CHATS_REQUEST";
export const ALL_CHATS_SUCCESS = "ALL_CHATS_SUCCESS";
export const ALL_CHATS_FAIL = "ALL_CHATS_FAIL";

export const NEW_CHAT_REQUEST = "NEW_CHAT_REQUEST";
export const NEW_CHAT_SUCCESS = "NEW_CHAT_SUCCESS";
export const NEW_CHAT_RESET = "NEW_CHAT_RESET";
export const NEW_CHAT_FAIL = "NEW_CHAT_FAIL";

export const DELETE_CHAT_REQUEST = "DELETE_CHAT_REQUEST";
export const DELETE_CHAT_SUCCESS = "DELETE_CHAT_SUCCESS";
export const DELETE_CHAT_FAIL = "DELETE_CHAT_FAIL";
export const DELETE_CHAT_RESET = "DELETE_CHAT_RESET";

export const UPDATE_CHAT_LATEST_MESSAGE = "UPDATE_CHAT_LATEST_MESSAGE";
export const UPDATE_CHAT_UNREAD_COUNT = "UPDATE_CHAT_UNREAD_COUNT";
export const INCREMENT_CHAT_UNREAD = "INCREMENT_CHAT_UNREAD";
export const RESET_CHAT_UNREAD = "RESET_CHAT_UNREAD";
export const SET_TOTAL_UNREAD = "SET_TOTAL_UNREAD";
export const MESSAGES_READ_BY_RECEIVER = "MESSAGES_READ_BY_RECEIVER";

export const CLEAR_ERRORS = "CLEAR_ERRORS";